import {
    ACTIVITIES,
    AGENDA,
    COMPANIES,
    CONTACTS,
    OPPORTUNITIES,
    SALESORDERS,
    TASKS,
} from 'constants/Entities';

// Domain constants
export const COPILOT_DOMAINS = {
    SSM: 'ssm',
};

// Action type constants
export const COPILOT_ACTION_TYPES = {
    ENTITY_FORM: 'entity_form',
    SHOW_ENTITY_DETAIL: 'show-entity-detail',
};

/**
 * Entity type mapping to entity constants
 * Maps entity trueNames to their entity constant objects
 */
export const COPILOT_ENTITY_TYPE_MAP = {
    [ACTIVITIES.trueName]: ACTIVITIES,
    [AGENDA.trueName]: AGENDA,
    [COMPANIES.trueName]: COMPANIES,
    [CONTACTS.trueName]: CONTACTS,
    [OPPORTUNITIES.trueName]: OPPORTUNITIES,
    [SALESORDERS.trueName]: SALESORDERS,
    [TASKS.trueName]: TASKS,
};
